__turbopack_context__.v({
  "bucketHeader": "ForYou-module-scss-module__d4Lrjq__bucketHeader",
  "forYouBucket": "ForYou-module-scss-module__d4Lrjq__forYouBucket",
});
